<ui-view name="nav"></ui-view>
<main id="content" class="content" [ngClass]="{ 'increase-nav': isBusinessUser, 'remove-nav-height': removeNavHeight }">
    <ui-view name="content"></ui-view>
</main>
<ui-view name="footer"></ui-view>
